module.exports = __webpack_public_path__ + "img/oct-dark.dc9f71e3.svg";